import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuGroupProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";

export const DropdownMenuGroup = (props: TDropdownMenuGroupProps) => (
  <DropdownMenuPrimitive.Group
    data-component="DropdownMenuGroup"
    {...props}
  />
);

DropdownMenuGroup.displayName = DropdownMenuPrimitive.Group.displayName;
